import { ScheduleFrequency } from "PFApp/analytics/types/export_analytics";
import { LoadingDots } from "PFComponents/loading_dots";
import Table from "PFComponents/table";
import React, { JSX, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Report, ReportStatus } from "../../../types/reports";
import css from "../../reports.module.scss";
import { ReportsTableTab } from "../reports_page";
import { useReportsColumns } from "./use_reports_columns";

type ReportsTableProps = {
  reports: Report[];
  isLoading: boolean;
  selectedTab: ReportsTableTab;
};

export const ReportsTable = ({ reports, isLoading, selectedTab }: ReportsTableProps): JSX.Element => {
  const { t } = useTranslation("insights", { keyPrefix: "reports" });
  const { generateColumns } = useReportsColumns();

  const filteredData = useMemo(() => {
    if (selectedTab === ReportsTableTab.NotScheduled) {
      return reports.filter(({ schedule }) => schedule?.repeat === ScheduleFrequency.No);
    }

    if (selectedTab === ReportsTableTab.Scheduled) {
      return reports.filter(({ schedule }) => schedule?.repeat !== ScheduleFrequency.No);
    }

    return reports;
  }, [selectedTab, reports]);

  const tableData = filteredData.map((item) => {
    if (
      !item.schedule &&
      (item.status === ReportStatus.InProgress || item.status === ReportStatus.Cancelled)
    ) {
      return {
        ...item,
        disabled: true,
        message: t("table.preparingDownload")
      };
    }
    return item;
  });

  return (
    <div className={css.tableContainer}>
      {isLoading && <LoadingDots circlesEnabled />}
      {!isLoading && (
        <Table<Report>
          tableData={tableData}
          generateColumns={generateColumns(selectedTab)}
          simplePaginationEnabled
        />
      )}
    </div>
  );
};
